// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m7-0";
export var fileList = "_m7-2";
export var removeFileButton = "_m7-1";